import { Routes } from '@angular/router';

export const routes: Routes = [

       { path: '', redirectTo: 'home', pathMatch: 'full' },

    // {
    //     path: '',
    //     loadComponent: () => import('./home/home.component').then(m => m.HomeComponent)
    //   },
      {
        path: 'home',
        loadComponent: () => import('./home/home.component').then(m => m.HomeComponent)
      },
    

      {
        path: 'about',
        loadComponent: () => import('./about/about.component').then(m => m.AboutComponent)
      },
      {
        path: 'admindash',
        loadComponent: () => import('./admin/admindash/admindash.component').then(m => m.AdmindashComponent)
      },
      {
        path: 'sale',
        loadComponent: () => import('./sale-voucher/sale-voucher.component').then(m => m.SaleVoucherComponent)
      },

      {
        path: 'testlist',
        loadComponent: () => import('./testlist/testlist.component').then(m => m.TestlistComponent)
      },


      {
        path: 'healthpackage',
        loadComponent: () => import('./healthpackage/healthpackage.component').then(m => m.HealthpackageComponent)
      },

      {
        path: 'radiology',
        loadComponent: () => import('./radiology/radiology.component').then(m => m.RadiologyComponent)
      },
      {
        path: 'appointment',
        loadComponent: () => import('./appointment/appointment.component').then(m => m.AppointmentComponent)
      },
      {
        path: 'blogs',
        loadComponent: () => import('./blogs/blogs.component').then(m => m.BlogsComponent)
      },
      {
        path: 'contact',
        loadComponent: () => import('./contact/contact.component').then(m => m.ContactComponent)
      },
      

];
